import { Pipe, PipeTransform } from '@angular/core';
import { FacetConfigResponse as FacetGroup } from '@models/api-search.models';

/**
 * Get boolean based on if group has any selected facets
 */
@Pipe({
    name: 'hasActiveFacets',
    standalone: true
})
export class HasActiveFacetsPipe implements PipeTransform {
    transform(groups?: FacetGroup[]): boolean {
        if (!groups?.length) {
            return false;
        }
        return groups.some(group => group.values?.some(value => value.selected));
    }
}
